/* eslint-disable @typescript-eslint/no-explicit-any */
import { FilterFn } from '@tanstack/react-table'

declare module '@tanstack/table-core' {
  interface FilterFns {
    multiple: FilterFn<unknown>
    hasValues: FilterFn<unknown>
    date: FilterFn<unknown>
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dateBetweenFilterFn: FilterFn<any> = (rows, id, filterValues) => {
  if (!filterValues.from && !filterValues.to) return true
  const auxDate = rows.original[id].split(' ')[0].split('-')
  const rowDate = new Date(auxDate[2], auxDate[1] - 1, auxDate[0])
  const fromDate = new Date(filterValues.from)
  const toDate = new Date(filterValues.to)
  if (!filterValues.to)
    return (
      rowDate.getDate() === fromDate.getDate() &&
      rowDate.getMonth() === fromDate.getMonth() &&
      rowDate.getFullYear() === fromDate.getFullYear()
    )
  if (rowDate >= fromDate && rowDate <= toDate) return true
  return false
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hasValuesFilterFn: FilterFn<any> = (rows, id, filterValue) => {
  if (!filterValue.length) return true
  return filterValue.every((value: string) => rows.original[id].includes(value.toLowerCase()))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const multipleValuesFilterFn: FilterFn<any> = (rows, id, filterValue) => {
  if (!filterValue.length) return true
  return filterValue.includes(rows.original[id].toLowerCase())
}

const filterFns = {
  date: dateBetweenFilterFn,
  hasValues: hasValuesFilterFn,
  multiple: multipleValuesFilterFn,
}

export { dateBetweenFilterFn, filterFns }
